/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentSyncResponse {
    getFixupPrototypeFunction() { return AwsSsmDocumentSyncResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentSyncResponse>): AwsSsmDocumentSyncResponse {
        let obj = Object.assign(new AwsSsmDocumentSyncResponse(), model);
        AwsSsmDocumentSyncResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentSyncResponse>): AwsSsmDocumentSyncResponse {
        if (!model) return null;
        return AwsSsmDocumentSyncResponse.newInstance(<AwsSsmDocumentSyncResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentSyncResponse) {
        if (!obj) return;

        models.AwsSsmDocumentSyncResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentSyncResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentSyncResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of cloud account ids for which manual sync triggered.
     */
    allowed_cloud_accounts: Array<string>;

    /**
     * List of cloud account ids for which user may not have access or invalid id
     */
    denied_cloud_accounts: Array<string>;

}
